<template>
  <v-list-item
    :to="{ name: to }"
    exact
    link>
    <v-list-item-icon v-if="iconPrepend && icon">
      <v-icon>{{ icon }}</v-icon>
    </v-list-item-icon>

    <v-list-item-content>
      <v-list-item-title>{{ title }}</v-list-item-title>
    </v-list-item-content>

    <v-list-item-icon v-if="!iconPrepend && icon">
      <v-icon>{{ icon }}</v-icon>
    </v-list-item-icon>
  </v-list-item>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true
    },
    to: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      required: false,
      default: undefined
    },
    iconPrepend: {
      type: Boolean,
      required: false,
      default: false
    }
  }
}
</script>

<style scoped>

</style>
